import { Link } from "react-router-dom";
import { formatPrice } from "@/lib/i18n";
import { useStore } from "@/lib/store";
import ProductPlaceholder from "./ProductPlaceholder";

export default function ProductCard({ product, index = 0 }) {
  const { lang } = useStore();
  const name = lang === "fr" ? product.name_fr : product.name_en;
  const hasImage = Array.isArray(product.images) && product.images.length > 0 && product.images[0];

  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group relative rounded-2xl overflow-hidden border border-yellow-600/15 hover:border-yellow-400/50 transition-all duration-500"
      style={{
        background: "linear-gradient(180deg, rgba(255,255,255,0.03), rgba(0,0,0,0.5))",
        boxShadow: "0 20px 40px -20px rgba(0,0,0,0.6)",
        animation: `fadeUp 0.6s ease ${0.03 + (index % 12) * 0.04}s both`,
      }}
    >
      <div className="aspect-square overflow-hidden relative">
        {(product.stock ?? 0) <= 0 && (
          <div
            className="absolute inset-0 z-10 flex items-center justify-center"
            style={{ background: "rgba(0,0,0,0.55)", backdropFilter: "blur(2px)" }}
            data-testid={`out-of-stock-overlay-${product.slug}`}
          >
            <span
              className="text-[11px] font-black tracking-[0.3em] px-3.5 py-1.5 rounded-full uppercase"
              style={{
                background: "rgba(239,68,68,0.18)",
                border: "1px solid #EF4444",
                color: "#FCA5A5",
              }}
            >
              ○ Rupture
            </span>
          </div>
        )}
        {product.badge && (
          <span
            className="absolute top-3 left-3 z-20 text-[10px] font-black tracking-[0.25em] px-2.5 py-1 rounded-full"
            style={{
              background: "linear-gradient(180deg, #F4D77A, #D4AF37)",
              color: "#1a0f00",
              boxShadow: "0 4px 12px -4px rgba(212,175,55,0.7)",
            }}
          >
            ✦ {product.badge}
          </span>
        )}
        {hasImage ? (
          <img
            src={product.images[0]}
            alt={name}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
          />
        ) : (
          <div className="w-full h-full transition-transform duration-700 group-hover:scale-[1.04]">
            <ProductPlaceholder product={product} />
          </div>
        )}
      </div>
      <div className="p-5">
        <h3
          className="font-bold text-yellow-100 truncate"
          style={{ fontFamily: '"Oswald", system-ui', letterSpacing: "0.02em" }}
        >
          {name}
        </h3>
        <div className="flex items-center justify-between mt-2">
          <p
            className="text-yellow-300 font-black text-lg"
            data-testid={`product-price-${product.slug}`}
          >
            {formatPrice(product.price_gnf, lang)}
          </p>
        </div>
      </div>
    </Link>
  );
}
